import React, { FC } from 'react';

type RichTextAreaProps = {
  content: string | null | undefined;
  innerClassName?: string;
}

export const RichTextArea: FC<RichTextAreaProps> = ({
  content,
  innerClassName = "",
}) => {
  return (
    <div
      className={innerClassName}
      dangerouslySetInnerHTML={{ __html: content ?? "" }}
    />
  )
};
